'use client';
import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import Image from '../components/commercetools-ui/atoms/image';

// Error boundaries must be Client Components

// import { useFormat } from '../helpers/hooks/useFormat';

export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  // Didn't use formatMessage since it seems we don't have access to the I18n provider in error components.
  // Texts can be handled more elegantly when having a CMS.
  // const { formatMessage } = useFormat({ name: 'common' });
  const logoImage = 'images/viewrail-logo.svg';
  const customerSupportLink = 'https://www.viewrail.com/support/';

  return (
    // global-error must include html and body tags
    <html>
      <body>
        <div className={'container m-auto py-112 md:py-249 lg:max-w-[978px] lg:py-232'}>
          <div className="flex flex-col items-center gap-32">
            <Image
              loading={'eager'}
              src={logoImage}
              style={{ objectFit: 'cover' }}
              className="w-154 object-cover object-center md:w-180 lg:w-210 lg:object-left"
            />
            <div className={'flex flex-col items-center gap-16 text-center'}>
              <h1 className="body-text-2xlarge font-medium">This page isn&apos;t working</h1>
              <p className={'body-text-large leading-7'}>
                Oh no! We’re experiencing technical difficulties on our end. Our team is working to solve this issue.
                Please refresh or try again later. We appreciate your patience.
              </p>
            </div>
            <Link variant="primary" className="text-center" link={customerSupportLink} target={'_self'}>
              Contact Customer Support
            </Link>
          </div>
        </div>
      </body>
    </html>
  );
}
